import { removeLabels } from 'src/apps/web-sdks/services/api/LabelUpdateApiService';
import { IWebSdkTest } from 'src/apps/web-sdks/types/WebSdkDashboardServiceTypes';

import { LabelRemoval } from '../shared/types';

/**
 * Handle save action for removing labels
 */
export const handleSave = async (
	removals: LabelRemoval[],
	testRows: IWebSdkTest[],
	onClose: () => void,
	onSaveSuccess?: () => void
): Promise<void> => {
	if (removals.length === 0 || testRows.length === 0) {
		onClose();
		return;
	}

	const removalStrings = removals.map((removal) => removal.label.value.toString());
	await removeLabels(testRows, removalStrings);
	onSaveSuccess?.();
	onClose();
};
